import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'

import type { paths } from '../gen/tintin-device-alarm-service-schema'
import config from './req.config'
export type { paths as DeviceAlarmPaths }

export const deviceAlarmServiceReq = createFetchClient<paths>({
  ...config,
})

export const deviceAlarmServiceQuery = createClient<paths>(deviceAlarmServiceReq)
